export default __webpack_public_path__ + "static/media/normal-available_loan-mobile.4d31296f.jpg";